import { EbabAvatar } from '../Avatar';
import { IconButton } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

/** @component
 *  Creates the Avatar button component.
 * @param setAnchor
 * @returns {React.ReactElement}
 * @constructor
 */
export const AvatarButton = ({ onClick }) => {
    const style = { width: '40px', height: '40px' };
    return (
        <IconButton
            key='profile'
            onClick={onClick}
            sx={{ padding: 0 }}
            data-analyticsid='account-icon'
        >
            {EbabAvatar({ style: style })}
        </IconButton>
    );
};

AvatarButton.propTypes = {
    onClick: PropTypes.func.isRequired
};
